/**
 * Returns single media item when ID is valid and item exists in state
 *
 * @param state
 * @param id
 * @returns {null|*}
 */
export const findMediaItem = (state, id) => {
  if (!id) {
    return null;
  }

  return state.entities.media[id];
};

/**
 * Returns array of items in upload queue, sorted by created time
 *
 * @param state
 * @returns []
 */
export const selectUploadedItems = (state) => {
  const {
    media: {
      uploadQueue,
    },
  } = state;

  return Object.values(uploadQueue).sort((a, b) => b.startAt - a.startAt);
};

/**
 * Returns single item from uploaded queue by unique ID
 *
 * @param state
 * @param uploadId
 * @returns {*}
 */
export const selectUploadedItemByUniqId = (state, uploadId) => (
  state.media.uploadQueue[uploadId]
);

/**
 * Performs a filter to media items to select only specific type if it's set.
 *
 * @param type
 * @param type
 * @returns {*}
 */
const createFilterByType = (type = '') => {
  const additionalImageTypes = ['gallery', 'galleryImage', 'sliderImage', 'section'];
  const disabledTypeFilters = ['editor'];

  return (media) => {
    if (media.isUploading) {
      return true;
    }

    if (!type || type.length === 0) {
      return true;
    }

    if (disabledTypeFilters.includes(type)) {
      return true;
    }

    if (additionalImageTypes.includes(type) && media.type === 'image') {
      return true;
    }

    return media.type === type;
  };
};

/**
 * Returns an array of media from state
 *
 * @param state
 */
export const selectAllMediaItems = (state) => {
  const {
    entities: {
      media,
    },
  } = state;

  return Object.values(media)
    .sort((a, b) => b.id - a.id);
};

/**
 * Returns an array of media from state
 *
 * @param state
 */
export const selectMediaItems = (state) => {
  const {
    media: {
      library: {
        page = 1,
        searchPhrase = '',
      },
    },
    content: {
      mediaManagerContentType: type,
    },
  } = state;

  let items = selectAllMediaItems(state)
    .filter(createFilterByType(type));

  if (searchPhrase && searchPhrase.length) {
    const phrases = searchPhrase.toUpperCase().trim().split(' ');
    items = items.filter((item) => {
      const fullName = [item.filename, item.fileExtension, item.resolution].join('');

      return phrases.every(phrase => fullName.toUpperCase().includes(phrase));
    });
  }

  const perPage = 15;
  const total = items.length;
  const pages = Math.ceil(total / perPage);
  const mediaItems = items.slice(0, page * perPage);

  return {
    items: mediaItems,
    pagination: {
      page,
      pages,
      perPage,
      total,
      hasMorePages: page < pages,
      isFirstPage: page === 1,
      isLastPage: page === pages,
    },
  };
};

export default {
  selectUploadedItems,
  selectUploadedItemByUniqId,
  findMediaItem,
  selectMediaItems,
  selectAllMediaItems,
};



// WEBPACK FOOTER //
// ./src/selectors/media.js